import { render, staticRenderFns } from "./device-install2.vue?vue&type=template&id=f04f1c64&scoped=true&"
import script from "./device-install2.js?vue&type=script&lang=js&"
export * from "./device-install2.js?vue&type=script&lang=js&"
import style0 from "./device-install2.css?vue&type=style&index=0&id=f04f1c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04f1c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VCardText,VProgressCircular,VStepper,VStepperStep})
